module.exports = __webpack_public_path__ + "static/media/photo.9d6d95c9.png";